import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var AuthAPI = /** @class */ (function () {
    function AuthAPI(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    AuthAPI.initialize = function (basePath, fetchApi) {
        if (!AuthAPI.instance) {
            AuthAPI.instance = new AuthAPI(basePath, fetchApi);
        }
        return AuthAPI.instance;
    };
    AuthAPI.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'contact'
        });
        return new NocoHttpClient.ApiContactV1AuthApi(new Configuration(config));
    };
    return AuthAPI;
}());
export { AuthAPI };
